import React, { Component } from "react";
import "./style.scss";
// import { Appointments, TreatmentHistory, PurchaseHistory, PersonalDetails, Favourites } from './Details'
import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { NormalInput, NormalButton, TableWrapper } from "component/common";
import { getCustomerPointsAccount } from "redux/actions/customerPlus";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PDFViewer, PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";
import Invoice from "component/Admin/Report/Account/Invoice";
import { withTranslation } from "react-i18next";
import { getCommonApi } from "redux/actions/common";

export class MemberGetMemberTabClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    headerDetails: [
      {
        label: "Cust Name ",
        width: "100px",
        divClass: "justify-content-left text-center",
      },
      {
        label: "Code ",
        width: "100px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Reference",
        width: "100px",
        divClass: "justify-content-center text-center",
      },

      {
        label: "DOJ",
        width: "50px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Total Purchase",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-center text-center",
      },

      {
        label: "Points Earned for Referral",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-center text-center",
      },
    ],

    accountList: [],
    accountHeader: {},
    DetailList: [],
    isPrintPdfClick: false,
    oldDetailList: [],
    oldaccountHeader: {},
    isLoading: false,
    page: 1,
    meta: {},
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    this.getCustomerPointsAccount({});
    this.setState({
      isLoading: true,
    });
  }
  handlemainPagination = (page) => {
    this.getCustomerPointsAccount(page);
    console.log(page, "pagee");
  };

  getCustomerPointsAccount = (data) => {
    this.setState({
      isLoading: true,
    });
    let { accountHeader } = this.state;
    console.log(data);
    let { page = 1, limit = 12 } = data;
    this.props
      .getCommonApi(
        `customerpointsaccount/?cust_id=${this.props.id}
        &page=${page}&limit=${limit}`
      )

      .then((key) => {
        console.log(getCommonApi, "api");
        let { data, header_data } = key;
        let { accountList } = this.state;
        if (data) {
          console.log(key.data, "key");
          this.setState({
            accountList: key.data.dataList,
            meta: key.data.pagination,
          });
        }
        accountList = data;
        accountHeader = header_data;
        this.setState({ accountList, accountHeader, isLoading: false });
      });
  };

  handleOpenDetail = async (data, tab) => {
    let { activeTab } = this.state;
    activeTab = tab;

    await this.setState({
      activeTab,
    });
    if (tab === "detail") {
      this.getDetailList(data.id);
    } else {
      this.getOldDetailList(data.id);
    }
  };

  getDetailList = (id) => {
    this.props.getCommonApi(`productacclist/${id}`).then((key) => {
      let { data, header_data } = key;
      let { DetailList, accountHeader } = this.state;
      DetailList = data;
      accountHeader = header_data;
      this.setState({ DetailList, accountHeader });
    });
  };

  getOldDetailList = (id) => {
    this.props
      .getCommonApi(`productacclist/holditemacclist/?deposit_id=${id}`)
      .then((key) => {
        let { data, header_data } = key;
        let { oldDetailList, oldaccountHeader } = this.state;
        oldDetailList = data;
        oldaccountHeader = header_data;
        this.setState({ oldDetailList, oldaccountHeader });
      });
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });
    this.getAccountData();
  };

  render() {
    let {
      treatmentList,
      headerDetails,
      accountList = [],
      accountHeader = {},
      activeTab,
      detailHeader,
      DetailList,
      isPrintPdfClick,
      oldDetailList,
      olddetailHeader,
      oldaccountHeader,
      isLoading,
      meta,
    } = this.state;
    let {
      date,
      balance,
      outstanding,
      totalproduct_count,
      credit_balance,
      outstanding_balance,
      totalholdqty,
      sa_transacno_ref,
    } = accountHeader;
    let { t } = this.props;
    return (
      <div className="treatment-account">
        {console.log(accountList, "accountlist")}
        <div className="col-12 mt-2">
          <div className="table">
            <TableWrapper
              headerDetails={headerDetails}
              queryHandler={this.handlemainPagination}
              pageMeta={meta}
              // pageMeta={pageMeta}
              // isEmpty={accountList.length === 0 ? true:false}
            >
              {isLoading ? (
                <tr>
                  <td colSpan="16">
                    <div class="d-flex mt-5 align-items-center justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : accountList.dataList && accountList?.dataList.length > 0 ? (
                accountList?.dataList?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="text-left">{item.site_code}</div>
                      </td>
                      <td>
                        <div className="text-center">{item.date}</div>
                      </td>
                      <td>
                        <div className="text-center">{item.itm_desc}</div>
                      </td>
                      <td>
                        <div className="text-center">{item.transactionref}</div>
                      </td>
                      <td>
                        <div className="text-center">{item.type}</div>
                      </td>
                      <td>
                        <div className="text-center">{item.ref_source}</div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="16">
                    <div class="d-flex  align-items-center justify-content-center fs-18">
                      No data available
                    </div>
                  </td>
                </tr>
              )}
            </TableWrapper>
          </div>
        </div>
        <div className="col-12 d-flex justify-center">
          {activeTab === "detail" || activeTab === "old" ? (
            <NormalButton
              buttonClass={"back mr-3"}
              mainbg={true}
              className="col-12 fs-15 "
              label="Back"
              onClick={() => this.handleBack()}
            />
          ) : (
            ""
          )}
          {activeTab === "old" ? null : (
            <NormalButton
              buttonClass={"print"}
              // mainbg={true}
              className="col-12 fs-15 "
              label="Print"
              // outline={false}
              onClick={() => this.setState({ isPrintPdfClick: true })}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

export const MemberGetMemberTab = withTranslation()(
  connect(null, mapDispatchToProps)(MemberGetMemberTabClass)
);
